import Link from 'next/link';
import { type NotificationSeverity, NotificationDot } from '../NotificationDot/NotificationDot';

type AvatarProps = {
  label: string;
  href?: string;
  notificationSeverity?: NotificationSeverity;
};
function AvatarButton({ label, href = '', notificationSeverity }: AvatarProps) {
  return (
    <Link href={href} data-track-name="Profile">
      <div className="w-fit p-2 relative" data-testid="avatar-button">
        <div className="flex justify-center items-center h-8 w-8 rounded-full bg-avatar-background text-avatar-foreground">
          <span className="paragraph-s-strong" data-track-privacy="Mask">
            {label}
          </span>
        </div>
        <NotificationDot notificationSeverity={notificationSeverity} className="absolute bottom-2 right-2" data-testid="avatar-notification-dot" />
      </div>
    </Link>
  );
}

export { AvatarButton };
